"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GaugeNeedle;
var _react = _interopRequireDefault(require("react"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function GaugeNeedle(_ref) {
  var value = _ref.value,
    margin = _ref.margin;
  return function (_ref2) {
    var center = _ref2.center,
      valueScale = _ref2.valueScale,
      outerRadius = _ref2.outerRadius,
      innerRadius = _ref2.innerRadius;
    var radius = (outerRadius - innerRadius) / 2 + innerRadius;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("g", {
      transform: "rotate(".concat(valueScale(value) + 90, " ").concat(center[0], " ").concat(center[1], ")")
    }, /*#__PURE__*/_react["default"].createElement("polygon", {
      points: "".concat(center[0], ",").concat(center[1], " ").concat(center[0] - 2, ",").concat(center[1] - 2, " ").concat(center[0] + Math.sin(valueScale(0) * (Math.PI / 180)) * radius, ",").concat(outerRadius - Math.abs(Math.cos(valueScale(0) * (Math.PI / 180)) * radius), " ").concat(center[0] + 2, ",").concat(center[1] + 2, " ").concat(center[0], ",").concat(center[1])
    }), /*#__PURE__*/_react["default"].createElement("circle", {
      cx: center[0],
      cy: center[1],
      r: 5,
      style: {
        border: '2px solid #fff'
      }
    })), /*#__PURE__*/_react["default"].createElement("text", {
      x: center[0],
      y: center[1] + 20,
      textAnchor: "middle",
      dominantBaseline: "central",
      style: {
        fontSize: '2rem',
        fontWeight: 600
      }
    }, (0, _round2["default"])(value, 1)));
  };
}